export function parseUrl (urlToParse) {
  if (typeof window !== 'undefined') {
    let parser = document.createElement('a')
    parser.href = urlToParse
    return parser
  } else {
    var url = require('url')
    return url.parse(urlToParse)
  }
}

export function parseQueryParams (queryParamsString) {
  return queryParamsString
    .replace(/^\?/, '')
    .split('&')
    .reduce((acc, keyValue) => {
      const [key, value] = keyValue.split('=')
      acc[key] = decodeURIComponent(value)
      return acc
    }, {})
}



// WEBPACK FOOTER //
// ./frontend/scripts/utils/url.js